import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import { checkPiAnswer, pick, renderPiAnswer, renderPiUserAnswer, SolidPiInput } from "../commonSolidPi";

const triples = [
  { r: 3, h: 4, l: 5 },
  { r: 5, h: 12, l: 13 },
  { r: 6, h: 8, l: 10 },
  { r: 8, h: 15, l: 17 },
  { r: 9, h: 12, l: 15 },
];

export function generateTask() {
  const { r, h, l } = pick(triples);
  const k = r * l;
  return { type: "ConeLateralSurfaceAreaTask", data: { r, h, l, k, numeric: k * Math.PI } };
}

export function renderTask({ data }) {
  return (
    <div style={{ marginBottom: 12 }}>
      Stożek ma promień podstawy <InlineMath math={`${data.r}`} /> i tworzącą{" "}
      <InlineMath math={`${data.l}`} />. Oblicz pole powierzchni bocznej stożka.
    </div>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return <SolidPiInput value={userAnswer} onChange={onChange} disabled={disabled} label="P_b" />;
}

export function checkAnswer({ data }, userAnswer) {
  return checkPiAnswer(data.numeric, userAnswer);
}

export function renderAnswer({ data }) {
  return renderPiAnswer("P_b", data.k);
}

export function renderUserAnswer(userAnswer) {
  return renderPiUserAnswer(userAnswer, "P_b");
}

export function renderExplanation({ data }) {
  const { r, l, k } = data;
  return (
    <div style={{ display: "grid", rowGap: 8 }}>
      <p><strong>Krok 1.</strong> Pole powierzchni bocznej stożka liczymy ze wzoru:</p>
      <BlockMath math={`P_b=\\pi r l`} />
      <p><strong>Krok 2.</strong> Podstawiamy promień i tworzącą.</p>
      <BlockMath math={`P_b=\\pi\\cdot ${r}\\cdot ${l}=${k}\\pi`} />
      <p><strong>Odpowiedź:</strong> <InlineMath math={`P_b=${k}\\pi`} />.</p>
    </div>
  );
}
